import {React,useState,useContext} from 'react'
import axios from "axios";
import SixtySevenBarChart from "../../../../Components/SixtySevenBarChart";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../../App";
import {API_URL}  from '../../../../Constant';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth, getDay } from 'date-fns'
import {getLastFridayOfLastMonth, getLastFridayOfLastYear} from "../../../../Custom/Custom"



function SixtySevenGraph() {

    const [chart,setChart]=useState('bar_chart');
    const [startDate, setStartDate] = useState('');
    const [sixtySevenGraph,setSixtySevenGraph]=useState('');
    const years = Array.from({ length: getYear(new Date()) - 2018 }, (_, index) => 2019 + index);
    const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const config = {
    headers: {
        Authorization: `Bearer ${useContext(MyContextProvider).token}`,
    },
  };
    
 


const filterFriday = (date) => {
    if (date.getDay() === 5) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); 
      return date <= today;
    }
    return false;
  };


    const handleSubmit=async (e)=>{
      
      if(!startDate){
        toast.error(messages.DATE_MSG, messages.COLOR_RED);
        return;
      }
        showLoading(true);
        const inputDate = moment(new Date(startDate)).format("YYYY-MM-DD")
        const last_month_date=getLastFridayOfLastMonth(inputDate);
        const last_to_last_month_date=getLastFridayOfLastMonth(last_month_date);
        const  last_year_date=getLastFridayOfLastYear(inputDate);
        const  last_to_last_year_date=getLastFridayOfLastYear(last_year_date);
        const postData={
          current_week_date:inputDate,
          last_month_date:last_month_date,
          last_to_last_month_date:last_to_last_month_date,
          last_year_date:last_year_date,
          last_to_last_year_date:last_to_last_year_date
        }
        try {
          const response = await axios.post(`${API_URL}api/graph/Usp_SixtySevenNecessaryItemsPriceGraph`, postData,config);
          setSixtySevenGraph(response.data.data);
          showLoading(false);
        } catch (error) {
          showLoading(false);
          console.log(error)
        }

    }


return (
    <>
    <div className="container-fluid py-3">
       <ToastContainer />
       <GlobalLoading />
       <div className="card mx-3 mb-3">
         <div className="card-body pb-1">
          <div className="row align-items-center">
       
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                <label className="fw-bold h6">From Date</label>
                <DatePicker
                className="form-control calendar_icon"
                dateFormat="yyyy-MM-dd"         
                placeholderText="YY-MM-DD"         
                filterDate={filterFriday}
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                        {"<"}
                      </button>
                      <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                      >
                        {years.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <select
                        value={months[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                          changeMonth(months.indexOf(value))
                        }
                      >
                        {months.map((option,i) => (
                          <option key={i} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                        {">"}
                      </button>
                    </div>
                  )}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
           </div>
            <div className="col-xl-4 col-lg-12 mb-3">
                <label className="w-100 mb-2 fw-bold h6">Chart Type</label>
                <div className="form-check form-check-inline me-2">
                    <input type="radio" onChange={(e)=>(setChart(e.target.value))} checked={chart==='bar_chart'} className="form-check-input" id="radio1" name="bar_chart" value="bar_chart" />
                    <label className="form-check-label" htmlFor="radio1">Bar Chart</label>
                </div>
                <div className="form-check form-check-inline">
                    <input type="radio"  disabled onChange={(e)=>(setChart(e.target.value))} checked={chart==='line_chart'} className="form-check-input" id="radio2" name="line_chart" value="line_chart"/>
                    <label className="form-check-label" htmlFor="radio2" >Line Chart</label>
                </div>
            </div>

            <div className="col-xl-4 col-lg-12 mb-3">
               
                <button type="submit" onClick={handleSubmit} className="btn btn_orange">Show</button>
                <button type="button" id="print" className="btn btn_gray ms-1">Print</button>
            </div>
          </div>
        </div>
      </div>
        

        { chart==='bar_chart' &&
         sixtySevenGraph && <SixtySevenBarChart graphData={sixtySevenGraph} chartDetails={{"chart_type":"Sixty_Seven_Necessary_Chart"}} />
        }


    </div>
    </>
  )
}

export default SixtySevenGraph